import React, { useEffect, useState } from "react";
import logo from "../assests/kalu-logo.avif";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { FrontendURL } from "../APIUrls";

const Header = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const redirectToProperties = () => {
    navigate("/property");
  };

  // const redirectToProducts = () => {
  //   navigate("/products");
  // };

  const redirectToEnquiry = () => {
    navigate("/enquiry");
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      setUserData(userData);
    }
  }, []);

  const getLinkStyle = (page) => {
    return {
      color: location.pathname === page ? "#ff9200" : "black",
      cursor: "pointer",
    };
  };

  return (
    <header className="header">
      <Grid container spacing={2}>
        <Grid item xs={4} className="MenuClass">
          {userData !== null && (
            <div className="menuButtons">
              <div className="navMenu">
                <span
                  onClick={redirectToProperties}
                  style={getLinkStyle("/property")}
                >
                  Properties
                </span>
                {/* <span
                  onClick={redirectToProducts}
                  style={getLinkStyle("/products")}
                >
                  Categories
                </span> */}
                <span
                  onClick={redirectToEnquiry}
                  style={getLinkStyle("/enquiry")}
                >
                  Enquiries
                </span>
              </div>
            </div>
          )}
        </Grid>
        <Grid item xs={4} className="logoGrid">
          <div className="logo-container">
            <img src={logo} alt="Logo" className="logo-img" />
          </div>
        </Grid>
        <Grid
          item
          xs={4}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          {userData !== null && (
            <Button
              className="loginButton"
              variant="contained"
              color="success"
              type="submit"
              onClick={() => {
                localStorage.removeItem("userData");
                window.location.href = FrontendURL;
              }}
            >
              Logout
            </Button>
          )}
        </Grid>
      </Grid>
    </header>
  );
};

export default Header;
